import React from 'react';
import { YMaps, Map, Placemark } from 'react-yandex-maps';
import styles from './index.module.scss';

const DEFAULT_COORDINATES = [55.751574, 37.573856]; // Москва

const MapBlock = ({ blockData, path_to_folder, blockIndex }) => {
  const coordinatesContent = blockData?.block_content?.find(
    (content) =>
      (content.cotent_tag === 'coordinates' || content.content_tag === 'coordinates') &&
      content.content_text &&
      content.content_text !== 'none',
  );

  const addressContent = blockData?.block_content?.find(
    (content) =>
      (content.cotent_tag === 'address' || content.content_tag === 'address' || content.cotent_tag === 'adress' || content.content_tag === 'adress') &&
      content.content_text &&
      content.content_text !== 'none',
  );
  const addressText = addressContent?.content_text?.trim() || null;

  let coordinates = null;
  if (coordinatesContent?.content_text) {
    const coordsArray = coordinatesContent.content_text
      .split(',')
      .map((coord) => parseFloat(coord.trim()));
    if (coordsArray.length >= 2 && !isNaN(coordsArray[0]) && !isNaN(coordsArray[1])) {
      coordinates = [coordsArray[0], coordsArray[1]];
    }
  }

  const finalCoordinates = coordinates || DEFAULT_COORDINATES;

  if (!blockData?.block_content) {
    return null;
  }

  return (
    <YMaps
      query={{
        lang: 'ru_RU',
        load: 'package.full',
      }}>
      <div className={styles.mapBlock}>
        {addressText && (
          <div className={styles.mapAddressWrap}>
            <h2 className={styles.mapAddress}>{addressText}</h2>
          </div>
        )}
        <div className={styles.mapContainer}>
          <Map
            defaultState={{
              center: finalCoordinates,
              zoom: 16,
              controls: ['zoomControl', 'fullscreenControl'],
            }}
            width="100%"
            height="100%"
            modules={['control.ZoomControl', 'control.FullscreenControl']}>
            <Placemark
              geometry={finalCoordinates}
              options={{
                preset: 'islands#redIcon',
              }}
              properties={{
                hintContent: 'Местоположение',
                balloonContent: 'Мы здесь',
              }}
            />
          </Map>
        </div>
      </div>
    </YMaps>
  );
};

export default MapBlock;
